module.exports = __webpack_public_path__ + "img/googleplay.efb9a1dd.svg";